<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-layout row class="primary" wrap>
          <v-flex xs12 sm6 offset-sm3>
            <h3 class="mt-2  mb-2 white--text">Edit item</h3>
          </v-flex>
        </v-layout>
        <v-divider class="mb-3"></v-divider>

          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                v-model.trim="item.brandName"
                name="brandName"
                label="Brand Name"
                id="brandName"
                required></v-text-field>
            </v-flex>
          </v-layout>

        <v-layout row>
          <v-flex xs12>
            <form @submit.prevent="editItem">
              <v-layout row>
                <v-flex xs12 sm6 offset-sm3>
                  <v-text-field
                    v-model.trim="item.receiptAlias"
                    name="receiptAlias"
                    label="Receipt Alias"
                    id="receiptAlias"
                    required></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm6 offset-sm3>
                  <v-text-field
                    v-model.trim="item.scancode"
                    name="scancode"
                    label="Scancode"
                    id="scancode"
                    required></v-text-field>
                </v-flex>
              </v-layout>

            <!-- compare data()'tmpSellbyDate' (created when app loads products)
              to 'item.SellbyDate' to display existing sellBy date -->

              <v-layout row class="mb-2">
                <v-flex xs12 sm6 offset-sm3 >
                <v-dialog v-if="item.SellbyDate !== tmpSellbyDate"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :label="'SellBy date: ' +format(itemSellbyDate,'MM-DD-YYYY')"
                      v-model="itemSellbyDate"
                      id="SellbyDate"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model.trim="itemSellbyDate" scrollable actions>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                          <v-btn flat color="primary" @click="save">OK</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>

           <!-- display defaults and bind to data() 'SellbyDate'  -->

                  <v-dialog v-else
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        label="SellBy Date"
                        v-model="SellbyDate"
                        id="SellbyDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="SellbyDate" scrollable actions>
                        <template slot-scope="{ save, cancel }">
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                            <v-btn flat color="primary" @click="save">OK</v-btn>
                          </v-card-actions>
                        </template>
                      </v-date-picker>
                    </v-dialog>
                  <!-- <p v-show="item.lastEditDate !== ''"><em>Last edited: {{item.lastEditDate | formatDateShort}}</em></p> -->
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm6 offset-sm3 mb-3>
                  <v-btn small class="primary mr-4" type="submit">Save</v-btn>
                  <v-btn small class="secondary" @click="cancel">Cancel</v-btn>
                  <v-btn small flat class="info mt-3" @click="duplicate">Duplicate</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import format from "date-fns/format";
import addWeeks from "date-fns/add_weeks"
import { copyObject } from '../mixins/utilities.js'
import * as firebase from "firebase"
export default {
  props: ["item", "from"],
  data() {
    return {
      SellbyDate: "",
      itemSellbyDate: format(this.item.SellbyDate, "YYYY-MM-DD"),
      tmpSellbyDate: this.$store.state.defaultSellByDate,
      itemOrig: copyObject(this.item)
    };
  },
  methods: {
    editItem() {
      const today = new Date();

      // standardize item keys with the legacy db for item updates
      
      const editedItem = {
        id: this.item.id,
        Scancode: document.getElementById("scancode").value,
        ReceiptAlias: document.getElementById("receiptAlias").value,
        Brand: document.getElementById("brandName").value,
        SellbyDate: document.getElementById("SellbyDate").value,
        creatorId: this.item.creatorId,
        editedBy: this.$store.state.user.userId,
        lastEditDate: format(today, "MMM Do YYYY h:mm A")
      };
      this.$store.state.loc = this.from
      this.$store.dispatch("editItem", editedItem)
    },
    duplicate() {
      const today = new Date();
      const duplicateItem = {
        Scancode: document.getElementById("scancode").value,
        ReceiptAlias: document.getElementById("receiptAlias").value,
        Brand: document.getElementById("brandName").value,
        SellbyDate: "",
        creatorId: this.item.creatorId,
        editedBy: this.$store.state.user.userId,
        lastEditDate: format(today, "MMM Do YYYY h:mm A"),
        reorderDate: ""
      };
      this.$store.commit("clearLoadedProduct");
      this.$store.commit("loadProduct", duplicateItem);
      this.$store.state.loc = this.from
      this.$router.push('/duplicateItem')
    },
    format(val) {
      return format(val, "MM-DD-YYYY");
    },
    cancel() {
      this.$store.state.loc = this.from
      this.$store.dispatch("editItem", this.itemOrig)
    }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/editItem.vue